import request from './services/axios.js'

// 获取上传视频签名
export const getUploadVideoSign = () => {
  return request({
    url: 'ebook/signature/getSign',
    method: 'get'
  })
}
// 上传成功后向后端更新视频信息
export const setVideoInfo = (params) => {
  return request({
    data: params,
    url: 'ebook/media/addVideo',
    method: 'POST'
  })
}
// 获取视频列表
export const getVideoList = (params) => {
  return request({
    params,
    url: 'ebook/media/getVideoByQuery',
    method: 'get'
  })
}

// 获取视频详情
export const getVideoInfo = (params) => {
  return request({
    url: 'ebook/media/getVideoInfo',
    method: 'get',
    params
  })
}

// 删除单个视频
export const deleteVideo = (params) => {
  return request({
    url: 'ebook/media/delVideo',
    method: 'POST',
    params
  })
}

// 视频编辑保存
export const editVideo = (params) => {
  return request({
    url: 'ebook/media/editVideo',
    method: 'POST',
    data: params
  })
}

// 获取微信配置
export const getWXConfig = (params) => {
  return request({
    params,
    url: 'ebook/media/wxShareParams',
    method: 'get'
  })
}

// 添加视频浏览量
export const addPv = (params) => {
  return request({
    params,
    url: 'ebook/media/addPv',
    method: 'get'
  })
}
